document.addEventListener('DOMContentLoaded', function() {

    let targetContainer = document.querySelector('.custom-section-id-top-fp-banner');
    if (targetContainer) {
        let html = targetContainer.innerHTML;
        html = html.replace(/#standup2standout/gi, '<span style="color: #e53935;">#standup2standout</span>');
        html = html.replace(/#standout2standup/gi, '<span style="color: #1c2340;">#standout2standup</span>');
        targetContainer.innerHTML = html;
    }


    // Open modal on button click
    const imgButtons = document.querySelectorAll('.img--box');
    if (imgButtons.length > 0) {
        imgButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
            const modal = btn.parentNode.querySelector('.img-modal');
            if (modal) {
                modal.classList.add('active');
                document.body.style.overflow = 'hidden';
            }
            });
        });
    }

    // Close modal on overlay or close button click
    document.querySelectorAll('.img-modal').forEach(function (modal) {
    // Overlay click
    const overlay = modal.querySelector('.img-modal__overlay');
    if (overlay) {
        overlay.addEventListener('click', function () {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        });
    }
    // Close button click
    const closeBtn = modal.querySelector('.modal__close-button');
    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        });
    }
    });

    // Optional: Close modal on Escape key
    document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        document.querySelectorAll('.img-modal.active').forEach(function (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        });
    }
    });

});